export default "__VITE_ASSET__ISbGVG7Z__"